import Immutable from 'immutable';
import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setAllRejectionTypes = (state, { allRejectionTypesData }) => {
  if (!allRejectionTypesData) return state;
  return state.merge({ allRejectionTypesData });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_ALL_REJECTION_TYPES,
    actionFunction: setAllRejectionTypes,
  },
];
